import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

import Container from 'components/Container';

interface PropTypes {
  name?: string;
  missionStatement?: string;
  logoImage?: string;
  image?: string;
  onClickGetStarted?: () => void;
}

const Hero = (props: PropTypes): JSX.Element => {
  const theme = useTheme();
  // const schoolContext = useContext(SchoolContext);
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const LeftSide = () => (
    <Box data-aos={isMd ? 'fade-right' : 'fade-up'} display="flex" flexDirection="column">
      {props.logoImage && (
        <Box
          marginBottom={2}
          alignSelf="center"
          component={'img'}
          loading="lazy"
          src={props.logoImage}
          width={{ xs: '50%' }}
        />
      )}
      <Box marginBottom={2}>
        <Typography variant="h2" component="h1" color="text.primary" align="center" sx={{ fontWeight: 700 }}>
          {props.name}
        </Typography>
      </Box>
      {props.missionStatement && (
        <Box marginBottom={3}>
          <Typography variant="h6" component="p" color="text.secondary" align="center">
            {props.missionStatement}
          </Typography>
        </Box>
      )}
      {props.onClickGetStarted && (
        <Box alignSelf="center">
          <Button variant="contained" color="primary" size="large" onClick={props.onClickGetStarted}>
            Get started
          </Button>
        </Box>
      )}
    </Box>
  );

  const RightSide = (): JSX.Element => {
    return (
      <Box
        sx={{
          height: { xs: 'auto', md: 1 },
          '& img': {
            objectFit: 'cover',
          },
        }}
      >
        <Box
          component={'img'}
          loading="lazy"
          src={props.image}
          height={{ xs: 'auto', md: 1 }}
          maxHeight={{ xs: 300, md: 1 }}
          width={1}
          maxWidth={1}
        />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: 1,
        height: 1,
        overflow: 'hidden',
      }}
    >
      <Container paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
        <Box display={'flex'} flexDirection={{ xs: 'column', md: 'row' }} position={'relative'} minHeight={{ md: 600 }}>
          <Box width={1} order={{ xs: 2, md: 1 }} display={'flex'} alignItems={'center'}>
            <Container>
              <LeftSide />
            </Container>
          </Box>
          <Box
            sx={{
              flex: { xs: '0 0 100%', md: '0 0 50%' },
              position: 'relative',
              maxWidth: { xs: '100%', md: '50%' },
              order: { xs: 1, md: 2 },
            }}
          >
            <Box
              sx={{
                width: { xs: 1, md: '50vw' },
                height: '100%',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  overflow: 'hidden',
                }}
              >
                {props.image && (
                  <Box
                    sx={{
                      overflow: 'hidden',
                      left: '0%',
                      width: 1,
                      height: 1,
                      position: { xs: 'relative', md: 'absolute' },
                      clipPath: {
                        xs: 'none',
                        md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                      },
                      shapeOutside: {
                        xs: 'none',
                        md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                      },
                    }}
                  >
                    <RightSide />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      <Divider />
    </Box>
  );
};

export default Hero;
